import { connect } from 'react-redux'
import { createItem } from 'components/Items/actions'
import { setWrapperRecipeSchemaItems } from 'services/Wrapper/actions'
import component from './component'


const mapStateToProps = state => ({
    isVisible: !!state.wrapper.recipeSchemaItems.length,
    items: state.wrapper.recipeSchemaItems
})

export default connect(
    mapStateToProps,
    {
        createItem,
        setWrapperRecipeSchemaItems
    }
)(component)
